import { Component } from '@angular/core';

@Component({
  selector: 'app-lstremolques',
  templateUrl: './lstremolques.component.html',
  styleUrls: ['./lstremolques.component.scss']
})
export class LstremolquesComponent {

}
